module.exports = __webpack_public_path__ + "img/r-line-short.5cb438ab.svg";